import DefaultList from "../List";

export default class CollapsibleSearchList extends DefaultList {

    constructor(props) {
        super(props);
        this.state = {
            ...this.state,
            searchCollapsed: false,
            pendingCollapse: false
        };
        this._loadedCount = 0;
    }

    onListSuccess(resp) {
        super.onListSuccess(resp);

        const items = resp?.items || resp?.data?.items || [];
        const count = items.size ?? items.length ?? 0;
        this._loadedCount = resp?.isFirstPage ? count : this._loadedCount + count;
    }

    componentDidUpdate(prevProps, prevState) {
        super.componentDidUpdate(prevProps, prevState);

        const { pendingCollapse, fetching, showError } = this.state;
        const loadJustFinished = prevState.fetching && !fetching;

        if (!pendingCollapse || !loadJustFinished) return;

        const hasRows = !showError && this._loadedCount > 0;

        this.setState(prev => ({
            pendingCollapse: false,
            searchCollapsed: hasRows ? true : prev.searchCollapsed
        }));
    }

    onSearchToggleChange = e =>
        this.setState({ searchCollapsed: !e.target.checked, pendingCollapse: false });

    beginSearch() {
        this._loadedCount = 0;
    }
}
